<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/B4QVzI/tc-custom/9781625675989.jpg?1721416440635" alt="This image is the cover for the book Shakespeare's Champion, Lily Bard"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shakespeare's Champion, Lily Bard
      </h1>
      <p class="bookDescription body article font2">
        <b>From Charlaine Harris, the #1 <i>New York Times</i> and <i>USA TODAY</i> bestselling author behind HBO’s hit series <i>True Blood</i> and NBC’s <i>Midnight, Texas</i>, the second installment in a mystery series that pulls no punches…</b><br/><br/>When Lily Bard agrees to open the gym for her sometime-boyfriend, it’s a sign of something she’s rejected for years—connection. Trust. The beginnings of being part of a community. And when she finds the corpse of a murdered bodybuilder waiting for her, it’s a sign she doesn’t know nearly as much about the home she’s chosen as she thought.<br/><br/>Shakespeare, Arkansas has seen three unsolved, seemingly unconnected murders in two months, and the town is tense with suspicion and rage. Lily’s contact on the police force develops an ulterior agenda. An anonymous white supremacist group is papering cars and threatening worse to come. And there’s a new man in town, someone whose face reminds Lily of the darkest time in her past…<br/><br/>Shakespeare needs answers, and Lily can’t rest until she has them. But there’s no telling how deep the rot spreads. And if she can’t trust anyone, she’ll be facing it down alone.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlaine Harris
      </h2>
      
      <p class="authorDescription body article">Charlaine Harris is a #1 <i>New York Times</i> bestselling author. Born and raised in the Mississippi River Delta area, Harris has been published in thirty-five languages, sold over 37 million copies of her work, and been selected as a 2021 Grand Master by the Mystery Writers of America, in addition to Lifetime Achievement honors from both Malice Domestic and RT Booklovers.  Three of her series have been adapted for television, as HBO’s True Blood, NBC’s Midnight, Texas, and the ongoing Aurora Teagarden movies on Hallmark Movies & Mysteries.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22ef5386